import React, { useEffect } from 'react';
import { FormViewContent } from 'components/FormViewContent';
import { connect, useSelector } from 'react-redux';
import { openSnackbar } from 'helpers/Notifier';
import { httpStatusEnum } from 'appconstants';
import { openConfirmation } from 'helpers/Confirmation';
import { bindLogger } from 'helpers/BindLogger';
import { bindActionCreators } from 'redux';
import atoms from 'ctsutheme/components/atoms';
import _ from 'lodash';
import { closeModal } from 'actions/common';
import { ProtocolIdSelector, ProtocolNumSelector } from 'selectors';
import { MUITextBox, ValidatorForm } from 'components/FormHelpers/FormInputs';
import { getEmptyValue } from 'helpers';
import { compose, withHandlers, withState } from 'recompose';
import { withAppContext } from '@ctsu/loader';
import { withChangeHandlers } from 'helpers/Change';
import { CTSUCardActions } from 'components';
import { saveEmbedded } from 'actions/protocols/opensetup';
import {
  GroupProtocolNumber, Step, Required, Days, Start, End, Comments
} from './index';

const { Divider } = atoms;

const StudyTitle = ({ state, handleChange }) => (
  <MUITextBox
    title="Study Title"
    multiline
    rowsMax="3"
    value={getEmptyValue(state && state.title)}
    onChange={handleChange}
    name="title"
  />
);

const EditEmbeded = (props) => {
  const {
    cancel,
    state,
    data,
    reset,
    handleChange,
    handleDateChange,
    setState,
    steps,
    setSteps,
    saveEmbedd
  } = props;

  useEffect(() => {
    setState({ ...data });
  }, [data, setState]);

  const { protocolLogistics } = useSelector(s => s.openData.openData);

  useEffect(() => {
    setSteps(
      _.map(protocolLogistics, ({ step, prlId, description }) => ({
        label: `Step : ${step} (${description})`,
        value: step,
        prlId
      }))
    );
  }, [protocolLogistics, setSteps]);

  return (
    <ValidatorForm onSubmit={saveEmbedd} className="key-value-pair-wrapper">
      <FormViewContent
        primaryText="Study Number"
        secondaryText={state.relatedProtocolNumber}
        name="relatedProtocolNumber"
      />
      <Divider />
      <FormViewContent
        primaryText="Study Title"
        name="studyTitle"
        secondaryText={
          (<StudyTitle state={state} handleChange={handleChange} />)
        }
      />
      <Divider />
      <FormViewContent
        primaryText="Group Protocol Number"
        secondaryText={
          (<GroupProtocolNumber state={state} handleChange={handleChange} />)
        }
        name="grpProtocolNumber"
      />
      <Divider />
      <FormViewContent
        primaryText="Step"
        secondaryText={
          (<Step state={state} setState={setState} steps={steps} />)
        }
        name="step"
      />
      <Divider />
      <FormViewContent
        primaryText="Study Type"
        secondaryText="EMBEDDED"
        name="embedded"
      />
      <Divider />
      <FormViewContent
        primaryText="Required?"
        secondaryText={
          (<Required state={state} setState={setState} />)
        }
        name="required"
      />
      <Divider />
      <FormViewContent
        primaryText="# Days"
        secondaryText={
          (<Days state={state} handleChange={handleChange} />)
        }
        name="days"
      />
      <Divider />
      <FormViewContent
        primaryText="Start Date"
        secondaryText={
          (<Start state={state} handleDateChange={handleDateChange} setState={setState} />)
        }
        name="startDate"
      />
      <Divider />
      <FormViewContent
        primaryText="End Date"
        secondaryText={
          (<End state={state} handleDateChange={handleDateChange} setState={setState} />)
        }
        name="endDate"
      />
      <Divider />
      <FormViewContent
        primaryText="Comments"
        secondaryText={
          (<Comments state={state} handleChange={handleChange} />)
        }
        name="comments"
      />
      <Divider />
      <CTSUCardActions
        clearClick={reset}
        cancelClick={cancel}
        hideCancel='show'
        disabled={_.isEqual(state, data)}
      />
    </ValidatorForm>
  );
};

const withConnectState = connect(
  (state, ownProps) => ({
    protocolId: ProtocolIdSelector(state),
    protocolNumber: ProtocolNumSelector(state),
    embeddedStudies: []
  }),
  dispatch => bindActionCreators(
    {
      onSaveEmbedded: saveEmbedded,
      onCloseModal: closeModal
    },
    dispatch
  )
);


const EditEmbededStudies = compose(
  withState('state', 'setState', {}),
  withState('steps', 'setSteps', []),
  withAppContext,
  withConnectState,
  withChangeHandlers,
  withHandlers({
    cancel: props => () => {
      const { onCloseModal } = props;
      onCloseModal();
    }
  }),
  withHandlers({
    saveEmbedd: props => postBody => {
      const {
        onSaveEmbedded, context, protocolId, cancel, state
      } = props;
      const confirmSave = () => {
        const postObj = {
          ...state,
          relationType: 'EMBEDDED',
          prtId: protocolId
        };
        bindLogger(onSaveEmbedded, context)(postObj, protocolId).subscribe(resp => {
          if (resp.status === httpStatusEnum.SUCCESS) {
            openSnackbar({
              // Will remove the below hardcoded message once this added to db config table
              message: 'Embedded Studies Information saved successfully.',
              // GetFromCtxValue(context, 'PROTOCOL_EMBEDDED_SUCCESS'),
              variant: 'success',
              name: 'embedded_studies'
            });
            cancel();
          }
        });
      };
      openConfirmation({
        // Will remove the below hardcoded message once this added to db config table
        message: 'Do you want to save the Embedded Studies information?', // GetFromCtxValue(context, 'PROTOCOL_EMBEDDED_CONFIRM'),
        onAction: confirmSave,
        name: 'embedded_studies'
      });
    }
  })
)(EditEmbeded);

export default EditEmbededStudies;
